import { MetaTagsProps, SubCategory } from "@/types";
import { content } from "./content";
import { images } from "./images";
import { OG_PATH } from "@/content";
import {
  createImageItems,
  createServicePoints,
} from "@/content/services/service-content-helpers";

const slug = "alarm-systems-sydney";
const serviceId = 2;

export const createMetaTags = (
  parentMetaTags: MetaTagsProps,
): { metaTags: MetaTagsProps; slug: string } => {
  const metaTags: MetaTagsProps = {
    title: "Alarm Systems Sydney | Ozy Wide Group",
    description:
      "Intruder alarm installation, zoning and support for homes, offices, retail premises and commercial spaces.",
    keywords:
      "alarm systems Sydney, intruder alarms, security alarms, alarm installation, alarm monitoring, home alarm systems, business alarms",
    url: `${parentMetaTags.url.replace(/\/$/, "")}/${slug}/`,
    ogImage: `${OG_PATH}service-${slug}.jpg`,
    type: "website",
  };

  return { metaTags, slug };
};

export const category: Omit<SubCategory, "headCategory" | "slug" | "metaTags"> =
  {
    id: serviceId,
    title: "Alarm Systems",
    description:
      "Intruder alarm installation, zoning and support for homes, offices, retail premises and commercial spaces.",
    points: createServicePoints(
      "Entry points and movement zones mapped",
      "Sensors, sirens and controls installed",
      "User codes and alerts set up clearly",
    ),
    images: createImageItems(images, "Alarm Systems Sydney"),
    content,
  };
